<template>
    <div class="main noscroll">
        <div class="main-center funnel_steps_page all_customers_page layout-column noscroll">
            <div class=" noscroll layout-column">
                <div class="funnel_apps_header">
                    <h1>Customers
                        <span class="panel_head_amount" v-if="paginationMeta.count">
                            <span v-if="paginationMeta.count < 25">
                                {{paginationMeta.count}}
                            </span>
                            <span v-else-if="currentPage !== paginationMeta.total_pages">
                                {{currentPage === 1 ? 1 : (currentPage*paginationMeta.per_page)-paginationMeta.per_page}} -
                                {{(currentPage)*paginationMeta.per_page}} from {{paginationMeta.count}}
                            </span>
                            <span v-else>
                                {{ paginationMeta.count-paginationMeta.per_page }} - {{ paginationMeta.count }} from {{paginationMeta.count}}
                            </span>
                        </span>
                    </h1>
	                <div class="flex"></div>
	                <div class="layout-row">
		                <v-button @click="exportCustomersOpen = true" border :disabled="!paginationMeta.count"
		                          label="Export customers"/>
	                </div>
                </div>

              <div class="funnel_apps scroll">
                <div class="customers-page-content">
                  <div class="search-container">
                      <input type="text" placeholder="Type to search..." class="search-input" v-model="searchInput" @input="searchValueChanged">

		                  <v-spinner v-if="loading" />
                  </div>

	                <div class="entries-table">
		                <div class="head " v-if="paginationMeta.count">
                      <span class="cell time sort-by">Last seen
												<inline-svg class="arrow" :src="require('@/assets/img/arrow-top.svg')" />
											</span>
			                <span class="cell customer-name">Customer</span>
			                <span class="cell customer"></span>
			                <span class="cell orders">Orders</span>
			                <span class="cell ltv">Spent</span>
			                <span class="cell actions"></span>
		                </div>
		                <div class="panel-body" v-if="paginationMeta.count">
			                <customer-item :customer="item" v-for="(item,index) in customers" :key="item.id" />
		                </div>
		                <div v-if="!paginationMeta.count" class="panel-body panel-body_2 empty-panel">
			                <p>No customers found</p>
		                </div>
	                </div>
                  <paginate
                      v-if="paginationMeta.count"
                      :pageCount="paginationMeta.total_pages"
                      :pageRange="10"
                      :forcePage="currentPage"
                      :clickHandler="clickCallback"
                      :prevText="'Prev'"
                      :nextText="'Next'"
                      :containerClass="'pagination pagination-root'"
                      :activeClass="'active'"
                  >
                  </paginate>
                </div>
              </div>
            </div>
        </div>

        <!-- CustomerDetails -->
<!--        <router-view />-->

	    <portal to="popup" v-if="customerId">
		    <popup-backdrop v-if="customerId" @close="closeCustomer">
			    <customer-details-new v-if="customerId" @close="closeCustomer"
			                          @done="closeCustomer"
			                          :customer-id="customerId" :level="0" />
		    </popup-backdrop>

	    </portal>
	    <portal to="popup" v-if="exportCustomersOpen">
		    <export-customers @close="exportCustomersOpen=false" />
	    </portal>
    </div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import CustomersStats from "@/components/widgets/CustomersStats.vue";
import CustomerDeletePopup from "@/components/popups/delete/CustomerDeletePopup.vue";
import {mapGetters} from "vuex"
import Loading from "@/components/Loading.vue"
import API from "@/api"
import {getSymbol} from "@/helpers/currencies";
import numbers from "@/helpers/numbers";
import OrderItem from "@/views/orders/order-item";
import CustomerItem from "@/views/customers/customer-item";
import VSpinner from "@/components/base/v-spinner";
import PopupBackdrop from "@/components/base/popup-backdrop";
import CustomerDetailsNew from "@/views/customers/customer-details-new";
import ExportCustomers from "@/views/customers/export-customers";
import VButton from "@/components/base/v-button";

export default {
	name: "Customers",
	title: "Customers | Funnelish™",
	components: {
		VButton,
		ExportCustomers,
		CustomerDetailsNew,
		PopupBackdrop,
		VSpinner,
		CustomerItem,
		OrderItem,
		MainSearch,
		CustomersStats,
		CustomerDeletePopup,
		Loading
	},
	mixins: [API],
	data() {
		return {
			exportCustomersOpen:false,
			loading: true,
			searchInput: '',
			paginationMeta: {
				count: 0,
				per_page: 0,
				total_pages: 0
			},
			customerId: '',
			customer: 0,
			page: 0,
			perPage: 25,
			query: "",
		}
	},
	computed: {
		...mapGetters(["getCustomersStore"]),
		currentPage() {
			var page = this.$route.query.page
			return page ? parseInt(page) : 1
		},
		customers(){
			return this.getCustomersStore;
		},
	},
	methods: {
		closeCustomer(){
			this.customerId='';
			this.$router.replace('/customers')
		},
		searchValueChanged() {
			// Reset current page before query to start from first page.
			this.$router.push({path: this.$router.path, query: {page: 1, perPage: 10, query: this.searchInput}});
			this.init();
		},
		clickCallback(pageNum) {
			this.$router.push({path: 'customers', query: {page: pageNum}});
			this.changePage(pageNum);
		},
		async changePage(page) {
			try {
				this.loading = true;
				// this.customers = [];

				let {customers, meta} = await this.api.customers.getAll(page);
				this.paginationMeta = meta

				this.$store.dispatch('SET_CUSTOMERS', customers);
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
		async init() {
			try {
				this.loading = true;

				let id = this.$route.query.id;
				if (id) {
					this.customerId = parseInt(id)
				}

				let {customers, meta} = await this.api.customers.getAll(this.currentPage - 1, this.perPage, this.searchInput);
				this.paginationMeta = meta

				this.$store.dispatch('SET_CUSTOMERS', customers);

			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.init();
	}
}
</script>

<style lang="scss" scoped>
.customers-page-content {
	padding: 60px 40px 80px;
	max-width: 2000px;
	margin: 0 auto;
	.entries-table {
		margin-top: 30px;
	}
}
</style>
